export const getMaxPointsAndPrice = (promotion) => {
    const maxPoints = Math.max(...promotion.variants.list.map((variant) => variant?.pointsDetails?.maxPoints || 0));
    const price = promotion.variants.list.find((variant) => (variant?.pointsDetails?.maxPoints || 0) === maxPoints)
        ?.price;

    return { maxPoints, price };
};
